import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import * as moment from 'moment';
import 'nvd3';
declare var Highcharts: any;
declare var nv: any;
import * as global from '../../../config/globals';
@Component({
  selector: 'maintenance',
  templateUrl: './maintenance.html',
  styleUrls: ['maintenance.css']
})

export class MaintenancePage implements OnInit{
  private data:Array<any> = [];
  pageSettings = pageSettings;
  listMantenimiento: any = [];
  tareaSeleccionada: any;
  loading = false;
  turno;
  menuMobile: any = [
    {
      Id: 1,
      Nombre: 'Home',
      Icono: 'fa-home',
      Href: '/gestionTareas',
    },
    {
      Id: 2,
      Nombre: 'Mantención',
      Icono: 'fa-cogs',
      Href: '/mantenciones',
    },
    {
      Id: 3,
      Nombre: 'Producción',
      Icono: 'fa-chart-bar',
      Href: '/produccion',
    },
    {
      Id: 4,
      Nombre: 'Actividades',
      Icono: 'fa-list-alt',
      Href: '/actividades',
    },
    {
      Id: 5,
      Nombre: 'Estandares',
      Icono: 'fa-server',
      Href: '/estandares',
    },    
  ]
  menuSelected: any = 2;

  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig
    ) {
        this.pageSettings.pageEmpty = false;
        this.pageSettings.pageWithoutSidebar = true;
        this.pageSettings.appSelected = null;
        config.justify = 'center';

  }

  async ngOnInit()  {


     this.getMantenimiento();
     this.get_Turno();
  }

  checkTodoList(item) {
    if (item.checked) {
      item.checked = false;
    } else {
      item.checked = true;
    }
  };
  
  async getMantenimiento(){
    try{
      this.listMantenimiento = await this.baseService.GetMantencionesProgramadas({fecha: null}).toPromise();
      var diaDespues:any = await this.baseService.GetMantencionesProgramadas({fecha: moment().add(1, 'days').format('YYYY-MM-DD')}).toPromise();
      diaDespues.forEach(item => {
        this.listMantenimiento.push(item);
      });
    }catch(error){
      console.log(error);
    }
  }

  async get_Turno(){
    try{
      var turno = await this.baseService.get_Turno({}).toPromise();
      this.turno = turno;
    }catch(error){
      console.log(error);
    }
  }

  doTextareaValueChange(ev) {
    try {
      this.tareaSeleccionada.motivo = ev.target.value;
    } catch(e) {
    }
  }
  modalCancelar(modal, tarea){
    this.tareaSeleccionada = tarea;
    this.modalService.open(modal, { size: 'lg' }) 
  }
}
